import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const placesFilterMixin = {
  data() {
    return {
      filteredPlaces: [],
    };
  },
  watch: {
    places: {
      immediate: true,
      handler() {
        this.filteredPlaces = this.places;
      },
    },
  },
  methods: {
    placesFilterMethod(query) {
      this.filteredPlaces = searchWithDiacritics(query, this.places, ['short_name']);
    },
    handlePlacesVisibleChange() {
      setTimeout(() => {
        this.filteredPlaces = this.places;
      }, 50);
    },
  },
};
